import { render, staticRenderFns } from "./sustainabilityCard.vue?vue&type=template&id=5ae7cca0&scoped=true&"
import script from "./sustainabilityCard.vue?vue&type=script&lang=js&"
export * from "./sustainabilityCard.vue?vue&type=script&lang=js&"
import style0 from "./sustainabilityCard.vue?vue&type=style&index=0&id=5ae7cca0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae7cca0",
  null
  
)

export default component.exports